/* eslint-disable object-shorthand */

export const PACKAGE_BUILD_DATE = '2026-11-02T08:54:36.018Z';
export const PACKAGE_NAME = '@invision/authentication';
export const PACKAGE_VERSION = '4.0.2-2694755';

export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};
